export default (state, { payload: { eventName, value } = {} }) => ({
  event: eventName,
  customerFeedback: {
    answer: value,
  },
});
